import { FC, useEffect, useState } from 'react'
import { Box, Button, CircularProgress, Divider, IconButton, Stack } from '@mui/material';
import tableIcon from '../../../../assets/images/appeal-process/TableIcon.png'
import { useNavigate } from "react-router-dom";
import GlobalSnackBar from 'UI/snackbar/GlobalSnackBar';
import dayjs from 'dayjs';
import { getProfileData } from 'store/features/getProfileDataSlice';
import { useAppDispatch, useAppSelector } from 'store/store';
import ApiClient from 'helpers/ApiClient';
import { getNotificationDetails } from 'store/features/notificationSlice';
import './review-form.scss'

const ReviewForm: FC<{ appealType: any, formData: any, handleAppeal: () => void, handleShowForm: () => void, appealFormInfo: any, formType: any, file: any, selectedPcnId: any }> = (props) => {
  const [toggleSnackbar, setToggleSnackbar] = useState({ message: "", isToggle: false, mode: "" });
  const [loadingState, setLoadingState] = useState<boolean>(false)
  const userProfileData = useAppSelector(state => state.profile.user)
  const [profile, setProfile] = useState(userProfileData)
  const dispatch = useAppDispatch();
  useEffect(() => { dispatch(getProfileData()); }, [dispatch])
  useEffect(() => { setProfile(userProfileData) }, [userProfileData])
  //Navigate to Appeal Process After Submit
  let navigate = useNavigate();

  //Handle Submit Function
  const handleSub = () => {
    handleAppealData()

  }
  const handleShowForm = () => {
    props.handleShowForm()
  }
  let tokenCreds = JSON.parse(
    localStorage.getItem("userData") ||
    sessionStorage.getItem("userData") ||
    "null"
  );

  const handleAppealData = async () => {
    let PcnFormData = new FormData();
    { props.selectedPcnId && (PcnFormData.append("pcnId", props.selectedPcnId)) }
    { !props.selectedPcnId && PcnFormData.append("pcnId", props.appealFormInfo.pcnId) };

    // PcnFormData.append("pcnId", props.appealFormInfo.pcnId);
    PcnFormData.append("appealType", props.formType === "independent-adjudicator" ? "independent" : props.formType);
    PcnFormData.append("userId", tokenCreds.id);
    PcnFormData.append("receivedNoticeThrough", props.appealFormInfo.receivedNoticeThrough);
    PcnFormData.append("groundReason", props.appealFormInfo.groundReason);
    PcnFormData.append("challengeReason", props.appealFormInfo.challengeReason);
    PcnFormData.append("file", props.appealFormInfo.file);
    {
      (props.formType === "formal" && (PcnFormData.append("rejectionCode", props.appealFormInfo.rejectionCode))) || (props.formType === "independent-adjudicator" && (PcnFormData.append("rejectionCode", props.appealFormInfo.rejectionCode)))
    }
    setLoadingState(true);
    ApiClient
      .post("appeal/add", PcnFormData)
      .then((res: any) => {
        setLoadingState(false);
        setToggleSnackbar({ message: res?.response?.data?.message, isToggle: true, mode: 'error' });
        navigate("/appeal-process", { replace: true });
        dispatch(getNotificationDetails());
      })
      .catch((err: any) => {
        setLoadingState(false);
        setToggleSnackbar({ message: err?.response?.data?.message, isToggle: true, mode: 'error' });
      });
  }

  return (
    <Box className="review-form" >
      <Box sx={{ position: "relative" }}> {toggleSnackbar.isToggle && (
        <GlobalSnackBar
          isOpenSnack={toggleSnackbar}
          setIsOpenSnack={setToggleSnackbar}
        />
      )}</Box>
      <div >
        <Stack className='flex-box' >
          <p className="form-heading">{props.appealType}</p>
          <IconButton onClick={handleShowForm} className="edit-btn">
            <img src={tableIcon} alt='IMG' />
          </IconButton>
        </Stack>
        <Divider sx={{ margin: "1rem 0" }} />
        <Box>
          <p className='sub-heading'>
            Review your appeal letter below before submitting:
          </p>

          <p className="address">
            {"17 Eaglesham Road Newton Mearns Glasgow G77 5BT"}
          </p>

          <p className='text'>
            London Local Authorities and Transport for London
          </p>

          <p className='text'>
            Dear {`${profile.firstName} ${profile.lastName}`},
          </p>

          <Box className='flex-start'>
            <p className="sub-heading2">
              Penalty Charge Notice Number:
            </p>
            <p className="sub-heading2">
              {props.formData.appealNumber}
            </p>
          </Box>
          <Box className='flex-start'>
            <p className="sub-heading2">
              Date of issue:
            </p>
            <p className="sub-heading2">
              {dayjs(props?.appealFormInfo?.pcnIssueDate).format("DD-MM-YYYY")}
            </p>
          </Box>
          <Box className='flex-start'>
            <p className="sub-heading2">
              Vehicle Registration:
            </p>
            <p className="sub-heading2">
              {props.formData.vehicleNumber}
            </p>
          </Box>
          <p className='text'>
            I am writing to formally challenge the above Penalty Charge Notice.
          </p>

          <p className='text'>
            On {dayjs(props?.appealFormInfo?.pcnIssueDate).format("DD-MM-YYYY")} my vehicle was issued with a Penalty Charge Notice for the reason of Failing to comply with a prohibition on certain type of vehicle(motor vehicle).<br />
            {props.formData.location} In Hawtrey Avenue/Thorndike Avenue Northolt(U) on {"29/09/2021"} at {"08:06"}
          </p>

          <p className='text'>
            In accordance with the Road Traffic Act 1991, my challenge is on the basis that the contravention did not occur. [State the reasons why].
          </p>

          <p className='text'>
            Please find enclosed evidence to this effect, in the form of [if evidence is available, state the details and why it backs up your case].
          </p>

          <p className='text'>
            For this reason I look forward to receiving notification that the Penalty Charge Notice has been cancelled within 28 days.
          </p>

          <p className='text'>
            Yours faithfully,<br />{`${profile.firstName} ${profile.lastName}`}
          </p>
        </Box >
        <Stack spacing={3} sx={{ textAlign: "center" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", marginBottom: "1rem" }}>
            <Button onClick={handleShowForm} className="btn-white"> Back</Button>
            <Button onClick={handleSub} type='submit' className='btn-primary' variant="contained">
              {loadingState ? (
                <>
                  <CircularProgress size={20} sx={{ color: "#FFFFFF", mr: 1 }} />
                </>
              ) : (
                <span>Submit</span>
              )}
            </Button>
          </Box>
        </Stack>
      </div>
    </Box>
  )
}

export default ReviewForm